import { AppLink } from "@/components/common/app-link";
import { Icon } from '@iconify/react';
import SectionPage from "@/components/common/section-page";

function Title({ title }: { title: string }) {
    return <h3 className="text-white text-xl font-bold">{title}</h3>
}

function FooterLink({ link, title }: { link: string, title: string }) {
    return <AppLink to={link} className="text-white opacity-50 hover:opacity-60 text-sm">{title}</AppLink>
}

function SocialLink({ link, icon }: { link: string, icon: React.ReactNode }) {
    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-sm rounded-full p-2 w-8 h-8 flex items-center justify-center"
        >
            {icon}
        </a>
    );
}

export default function FooterSiteOfficiel() {
    return <footer className="relative bg-footer bg-cover bg-center bg-no-repeat pt-20 pb-10 font-roboto">
        <SectionPage sectionType={"2xl"}>
            <div className="bg-[#001035] opacity-60 h-full w-full absolute top-0 left-0 z-0"></div>
            <div className="p-8 z-10 relative">
                {/* FOOTER CONTENT */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {/* THEMATIQUES */}
                    <div className="flex flex-col gap-4">
                        <Title title="Thématiques" />
                        <p className="flex flex-col gap-2">
                            <FooterLink link="/nature" title="Nature, BIodiversité et Activités de plein air" />
                            <FooterLink link="/art-de-vivre-gastro" title="Art de vivre et Gastronomie" />
                            <FooterLink link="/soleil-plage" title="Soleil et Plage" />
                            <FooterLink link="/culture-patrimoine-art" title="Culture, Art et Patrimoine" />
                        </p>
                    </div>

                    {/* COTE D'IVOIRE TOURISME */}
                    <div className="flex flex-col gap-4">
                        <Title title="Côte d'Ivoire Tourisme" />
                        <p className="flex flex-col gap-2">
                            <FooterLink link="/decouvertes/nos-inspirations-voyages" title="Nos inspirations voyages" />
                            <FooterLink link="/agenda" title="Agenda" />
                            <FooterLink link="/guide-de-voyage/infos-utiles" title="Infos utiles" />
                        </p>
                    </div>

                    {/* CONTACTS */}
                    <div className="flex flex-col gap-4">
                        <Title title="Nous suivre" />
                        <div className="flex gap-2">
                            <SocialLink link="https://www.facebook.com/tourismecotedivoire.ci/" icon={<Icon icon="line-md:facebook" />} />
                            <SocialLink link="https://www.instagram.com/cotedivoiretourisme.ci" icon={<Icon icon="line-md:instagram" />} />
                            <SocialLink link="https://twitter.com/ivoiretourisme" icon={<Icon icon="line-md:twitter-x" />} />
                            <SocialLink link="https://www.youtube.com/@CoteIvoireTourisme" icon={<Icon icon="line-md:youtube-filled" />} />
                            <SocialLink link="https://ci.linkedin.com/company/c%C3%B4te-d-ivoire-tourisme" icon={<Icon icon="line-md:linkedin" />} />
                            <SocialLink link="https://www.tiktok.com/@cotedivoire.tourisme" icon={<Icon icon="line-md:tiktok" />} />
                        </div>
                    </div>
                </div>

                {/* LEGAL */}
                <div className="flex flex-col items-center mt-12 border-t border-b text-center border-gray-300 text-white text-sm opacity-40 p-12">
                    <p className="mb-4">{`Siège : Cocody Ambassade, derrière la Banque Mondiale`}</p>
                    <p className="text-white text-sm">
                        01 BP 8538 ABIDJAN 01
                        <br />
                        Tél : + 225 27 22 22 41 10
                        <br />
                        Email : infos@visitcotedivoire-officiel.ci 
                    </p>
                </div>

                {/* COPYRIGHT */}
                <div className="flex justify-between mt-12">
                    <p className="text-white text-sm">{`© ${new Date().getFullYear()} Côte d'Ivoire Tourisme. Tous droits réservés.`}</p>
                </div>
            </div>
        </SectionPage>
    </footer>;
}
